import store from 'store'
import { startLoading as actionStartLoading, finishLoading as actionFinishLoading } from 'store/actionCreators/loading'

export const startLoading = () => store.dispatch(actionStartLoading())
export const finishLoading = () => store.dispatch(actionFinishLoading())
